import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tc } from 'utils/theme';

const StyledHelpMessage = styled.p`
  color: ${tc('helpMessage')};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.3px;
  padding: 0;
  margin: 5px 0 0 0;
`;

const FieldHelp = ({ help }) =>
  help && <StyledHelpMessage>{help}</StyledHelpMessage>;

FieldHelp.propTypes = {
  help: PropTypes.string,
};

FieldHelp.defaultProps = {
  help: '',
};

export default FieldHelp;
